import {
  ComponentFactoryResolver,
  ComponentRef,
  Directive,
  ElementRef,
  Input,
  OnInit,
  ViewContainerRef,
} from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faCopy } from '@fortawesome/free-regular-svg-icons';
import { Store } from '@ngrx/store';
import { IReducers } from '../../../store/reducers';
import { openSnackbar } from '../../../store/actions/page.action';

@Directive({
  selector: '[appCopyText]',
})
export class CopyTextDirective implements OnInit {

  @Input() appCopyText: boolean = true;

  copyEl: ComponentRef<FaIconComponent>;

  constructor(
    private readonly el: ElementRef,
    private readonly viewContainerRef: ViewContainerRef,
    private readonly componentFactoryResolver: ComponentFactoryResolver,
    private readonly store$: Store<IReducers>,
  ) {
  }

  ngOnInit() {
    if (!this.appCopyText) {
      return;
    }
    const factory = this.componentFactoryResolver.resolveComponentFactory(
      FaIconComponent,
    );

    this.copyEl = this.viewContainerRef.createComponent(factory);
    this.copyEl.instance.icon = faCopy;
    this.copyEl.instance.size = '1x';
    this.el.nativeElement.parentNode.insertBefore(
      this.copyEl.location.nativeElement,
      this.el.nativeElement.nextSibling,
    );
    this.copyEl.location.nativeElement.classList.add('copy-text');
    this.copyEl.location.nativeElement.addEventListener('click', () => {
      let value: string;
      if (this.el.nativeElement.tagName === 'INPUT') {
        value = this.el.nativeElement.value;
      } else {
        value = this.el.nativeElement.textContent;
      }

      navigator.clipboard.writeText(value);
      this.store$.dispatch(openSnackbar({
        snackbarData: {
          data: {
            message: `${value} copied to the clipboard`,
            type: 'success',
          },
        },
      }));
    });
    this.copyEl.instance.render();
  }

}
